// extracted by mini-css-extract-plugin
export default {"btn":"PrintableJobApplicationsRow_btn__qQAjc","table-number-cell":"PrintableJobApplicationsRow_table-number-cell__4SllI","tr":"PrintableJobApplicationsRow_tr__Ku8rT"};